import { SUCCESS } from '../../constants';
import { PREVIOUS_BOOKING, DELETE_PREVIOUS_BOOKING } from './action-types';

// There is a small window in the previous booking journey with no parkId, we add some custom logic so it doesn't break
const initialState = {
  booking: undefined,
  parkId: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PREVIOUS_BOOKING + SUCCESS: {
      const data = action?.payload?.response?.data?.data;
      return {
        ...state,
        booking: data || undefined,
        parkId: data?.parkId,
      };
    }
    case DELETE_PREVIOUS_BOOKING: {
      if (state.booking === undefined) {
        return state; // no change, avoid rerender
      }
      return {
        ...state,
        booking: undefined,
      };
    }
    default:
      return state;
  }
};

export default reducer;
